import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionHeading } from './ui/SectionHeading';
import { Stethoscope, Users, Cpu, Sparkles, Clock, Heart } from 'lucide-react';
export function WhyChooseUs() {
  const benefits = [{
    icon: <Stethoscope className="w-6 h-6" data-id="element-298" />,
    title: 'Diagnóstico personalizado',
    description: 'Evaluación médica detallada para crear un plan a tu medida.'
  }, {
    icon: <Users className="w-6 h-6" data-id="element-299" />,
    title: 'Equipo médico especializado',
    description: 'Profesionales altamente cualificados y en constante formación.'
  }, {
    icon: <Cpu className="w-6 h-6" data-id="element-300" />,
    title: 'Tecnología de última generación',
    description: 'Equipos avalados científicamente para máxima eficacia y seguridad.'
  }, {
    icon: <Sparkles className="w-6 h-6" data-id="element-301" />,
    title: 'Resultados naturales',
    description: 'Buscamos la mejor versión de ti, sin alterar tu esencia.'
  }, {
    icon: <Clock className="w-6 h-6" data-id="element-302" />,
    title: 'Seguimiento profesional',
    description: 'Acompañamiento antes, durante y después de cada tratamiento.'
  }, {
    icon: <Heart className="w-6 h-6" data-id="element-303" />,
    title: 'Atención humana',
    description: 'Un trato cálido y cercano en un ambiente de lujo y relajación.'
  }];
  return <section className="py-24 md:py-32 bg-background relative overflow-hidden" data-id="element-304">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-champagne/30 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-305" />

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-306">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-307">
          <div className="lg:col-span-4" data-id="element-308">
            <div className="sticky top-32" data-id="element-309">
              <SectionHeading title="¿Por qué elegir Libelle?" alignment="left" subtitle="La excelencia médica se une al lujo y confort para brindarte una experiencia transformadora." data-id="element-310" />
            </div>
          </div>

          <div className="lg:col-span-8" data-id="element-311">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-12" data-id="element-312">
              {benefits.map((benefit, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-313">
                  <div className="flex gap-6" data-id="element-314">
                    <div className="flex-shrink-0 w-12 h-12 rounded-full border border-gold flex items-center justify-center text-gold" data-id="element-315">
                      {benefit.icon}
                    </div>
                    <div data-id="element-316">
                      <h3 className="font-serif text-xl text-foreground mb-2" data-id="element-317">
                        {benefit.title}
                      </h3>
                      <p className="text-muted-foreground font-light leading-relaxed" data-id="element-318">
                        {benefit.description}
                      </p>
                    </div>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}